const EPSILON = 1e-4;
const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const normalize = (crop) => ({
  x: crop?.x ?? 0,
  y: crop?.y ?? 0,
  width: crop?.width && crop.width > 0 ? crop.width : 1,
  height: crop?.height && crop.height > 0 ? crop.height : 1
});
const isCropped = (crop) => {
  if (!crop) {
    return false;
  }
  const { width = 1, height = 1 } = crop;
  if (width <= 0 || height <= 0) {
    return false;
  }
  const normalized = normalize(crop);
  return normalized.x > EPSILON || normalized.y > EPSILON || normalized.width < 1 - EPSILON || normalized.height < 1 - EPSILON;
};
const toCropAttribute = (crop) => isCropped(crop) ? crop : null;
const toPixelCrop = ({ crop, sourceWidth, sourceHeight }) => {
  if (!isCropped(crop) || !sourceWidth || !sourceHeight) {
    return;
  }
  const normalized = normalize(crop);
  const x = clamp(Math.round(normalized.x * sourceWidth), 0, sourceWidth - 1);
  const y = clamp(Math.round(normalized.y * sourceHeight), 0, sourceHeight - 1);
  return {
    x,
    y,
    width: clamp(Math.round(normalized.width * sourceWidth), 1, sourceWidth - x),
    height: clamp(Math.round(normalized.height * sourceHeight), 1, sourceHeight - y)
  };
};
export {
  isCropped,
  normalize,
  toCropAttribute,
  toPixelCrop
};
//# sourceMappingURL=image-crop.js.map
